// @flow

import type {
  ArticleFeedbackEditableValuesType,
  ArticleFeedbackFetchParamsType,
  ArticleFeedbackType,
} from '../types';
import type {ResponseType} from 'app/utils/redux_v2';
import {createErrorHandler, get, patchJson} from 'app/utils/request';
import {gt} from 'app/utils/i18n';
import {KB_FEEDBACK_API_URL} from 'app/urls';

export const RECEIVE_KB_ARTICLE_FEEDBACK = 'RECEIVE_KB_ARTICLE_FEEDBACK';

export type ReceiveArticleFeedbackListType = {
  type: 'RECEIVE_KB_ARTICLE_FEEDBACK',
  query: ArticleFeedbackFetchParamsType,
  response: ResponseType<ArticleFeedbackType>,
};
export const ReceiveArticleFeedbackList = (
  query: ArticleFeedbackFetchParamsType,
  response: ResponseType<ArticleFeedbackType>
): ReceiveArticleFeedbackListType => ({
  type: RECEIVE_KB_ARTICLE_FEEDBACK,
  query,
  response,
});

const requestArticleFeedback = (params: ArticleFeedbackFetchParamsType) =>
  get(KB_FEEDBACK_API_URL, params);

export const fetchArticleFeedback =
  (params: ArticleFeedbackFetchParamsType) => (dispatch: SimpleDispatch) =>
    requestArticleFeedback(params).then(
      (response) => dispatch(ReceiveArticleFeedbackList(params, response)),
      createErrorHandler(
        gt('Unable to load feedback for this article'),
        dispatch
      )
    );

export const updateArticleFeedback =
  (
    feedback: ArticleFeedbackType,
    updatedContent: ArticleFeedbackEditableValuesType
  ) =>
  (dispatch: SimpleDispatch) =>
    patchJson(feedback.url, updatedContent).then(() =>
      dispatch(fetchArticleFeedback({article_id: feedback.article}))
    );
